"use client";
import * as React from "react";
const SvgLocationFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6 0C2.96 0 .5 2.5.5 5.6.5 9.8 6 16 6 16s5.5-6.2 5.5-10.4C11.5 2.5 9.04 0 6 0m0 7.6c-1.08 0-1.96-.9-1.96-2s.88-2 1.96-2 1.96.9 1.96 2-.88 2-1.96 2" }));
export {
  SvgLocationFilled as default
};
